<template>
  <div class="authentication">
    <!-- ログイン時 -->
    <div v-if="user.uid" key="login" class="navbar-item">
      <v-content>
        <div v-if="!this.$route.params.id" class="">
          <Rooms />
        </div>
        <div v-else class="">
          <Chat ref="chat"></Chat>
        </div>
      </v-content>
      <v-navigation-drawer
        disable-resize-watcher
        mobile-break-point="900"
        :value.sync="drawer"
        app
        right
        clipped
      >
        <Sidebar />
      </v-navigation-drawer> 
    </div>
    <!-- 未ログイン時 -->
    <div v-else key="logout">
      <Top />
    </div>
  </div>  
</template>
<script>
import firebase from 'firebase'
import Firebase from './../firebase'
import Top from '@/components/Top.vue'
import Rooms from '@/components/Rooms.vue'
import Chat from '@/components/Chat.vue'
import Sidebar from '@/components/Sidebar.vue'

export default {
  components: {
    Top,
    Rooms,
    Chat,
    Sidebar
  },
  data () {
    return {
    }
  },
  created () {
    Firebase.onAuth()
  },
  beforeRouteUpdate (to, form, next) {
    this.$refs.chat.Refresh(to.params.id)
    next()
  },
  computed: {
    user() {
      return this.$store.getters.user
    },
    drawer () {
      return this.$store.state.drawer
    }
  },
  methods: {
    // ログイン処理
    doLogin() {
      Firebase.login();
    },
    // ログアウト処理
    doLogout() {
      Firebase.logout();
    },
  },
}
</script>

